module.exports = __webpack_public_path__ + "static/img/验收证书.773f4eee.jpg";